import { render, staticRenderFns } from "./GroupPrice.vue?vue&type=template&id=068dc3e2&scoped=true"
import script from "./GroupPrice.vue?vue&type=script&lang=js"
export * from "./GroupPrice.vue?vue&type=script&lang=js"
import style0 from "./GroupPrice.vue?vue&type=style&index=0&id=068dc3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068dc3e2",
  null
  
)

export default component.exports